module.exports = __webpack_public_path__ + "static/media/glutten-freen-min.f57462ba.png";